import * as aviso from '@/api/aviso'

const state = {
  list: [],
  listaSelect: [],
  filtros: {page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDel: false,
  listUsuario: []
}

const mutations = {
  SETAVISOS (state, payload) {
    state.list = payload.list
  },
  MODALADD (state, payload) {
    state.modalAdd = payload
  },
  MODALEDIT (state, payload) {
    state.modalEdit = payload
  },
  MODALCONFDEL (state, payload) {
    state.modalConfDel = payload
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETAVISOSUSUARIO (state, payload) {
    state.listUsuario = payload
  }
}

const actions = {
  modalAdd: function ({ commit }, payload) {
    commit('MODALADD', payload)
  },
  modalEdit: function ({ commit }, payload) {
    commit('MODALEDIT', payload)
  },
  modalConfDel: function ({ commit }, payload) {
    commit('MODALCONFDEL', payload)
  },
  async get ({ commit }, payload) {
    return aviso.get(payload)
  },
  async getAvisos ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await aviso.getAvisos(payload)
    commit('SETAVISOS', data)
    commit('SETPAGINATE', data.pages)
  },
  async getAvisosFiltro ({ commit, dispatch }) {
    let data = await aviso.getAvisos(state.filtros)
    if (state.filtros.page > data.pages) dispatch('setPage', data.pages)
    else {
      commit('SETAVISOS', data)
      commit('SETPAGINATE', data.pages)
    }
  },
  async add ({ commit }, payload) {
    return aviso.add(payload)
  },
  async edit ({ commit }, payload) {
    return aviso.edit(payload)
  },
  async del ({ commit }, payload) {
    return aviso.del(payload)
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getAvisos', state.filtros)
  },
  async getAvisosUsuario ({ commit }, payload) {
    let data = await aviso.getByUsuario(payload)
    commit('SETAVISOSUSUARIO', data.instancia)
  },
  async marcarComoLido ({ commit }, payload) {
    return aviso.marcarComoLido(payload)
  },
  async getAvisoNaoLido ({ commit }) {
    let avisoEnvelope = await aviso.naoLido()
    return avisoEnvelope.instancia
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/avisos.js